import React, { PropsWithChildren } from 'react';
import { Flex } from 'antd';

const PAGE_HEIGHT = 'calc(100vh - 64px - 32px)'; // topbar = 64px, double marging = 32px

function FullPageHeightContainer({ children }: PropsWithChildren) {
  return (
    <Flex vertical style={{ minHeight: PAGE_HEIGHT }}>
      {children}
    </Flex>
  );
}

export default FullPageHeightContainer;
